import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  MessageBarStore,
  Modal,
  SOFTLINE_FEATURE_MESSAGE_BAR } from '@softline/ui-core';
import { WorkNote } from '../../data/work-note';
import { Store } from '@softline/core';
import {
  SOFTLINE_FEATURE_WORK_NOTE_COLLECTION,
  WorkNoteCollectionStore } from '../../arbeitsschein.shared';


import { SignaturePadComponent } from '@softline/ui-core/draw';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-signature-dialog',
    templateUrl: './signature-dialog.component.html',
    styleUrls: ['./signature-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslatePipe,
    SignaturePadComponent]
})
export class SignatureDialogComponent implements OnInit, Modal<null> {
  isSaving = false;
  close!: (result: null) => void;
  workNote!: WorkNote;

  constructor(private store: Store) {}

  private static dataURIToBlob(signatureString: string): Blob {
    const match = /data:(.*?);base64,(.*)/g.exec(signatureString);

    if (!match) {
      throw Error('invalidDataUri');
    }
    const byteString: string = window.atob(match[2]);
    const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array: Uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([int8Array as any], { type: match[1] });
  }

  ngOnInit(): void {}

  registerCloseHandler(handler: (result: null) => void) {
    this.close = handler;
  }

  async sign(signature: string): Promise<void> {
    const files = {
      files: [SignatureDialogComponent.dataURIToBlob(signature)] };

    try {
      this.isSaving = true;
      const uploadResult = await this.uploadSignature(this.workNote, files);
      this.isSaving = false;

      if (!uploadResult) {
        await this.showUploadError();
        return;
      }

      await this.showUploadSuccess();
      this.close(null);
    } catch (e) {
      console.log(e);
      this.isSaving = false;
      await this.showUploadError();
    }
  }

  private async showUploadError(): Promise<void> {
    await this.store.dispatch(
      SOFTLINE_FEATURE_MESSAGE_BAR,
      MessageBarStore.actions.error,
      {
        title: 'Fehler',
        duration: 60000,
        message: 'Beim Speichern der Unterschrift ist ein Fehler aufgetreten!' }
    );
  }

  private async showUploadSuccess(): Promise<void> {
    await this.store.dispatch(
      SOFTLINE_FEATURE_MESSAGE_BAR,
      MessageBarStore.actions.success,
      {
        title: 'Unterschrift gespeichert',
        message: 'Die Unterschrift wurde erfolgreich gespeichert!' }
    );
  }

  private async uploadSignature(
    workNote: WorkNote,
    signature: { files: Blob[] }
  ): Promise<WorkNote | undefined> {
    return await this.store.dispatch(
      SOFTLINE_FEATURE_WORK_NOTE_COLLECTION,
      WorkNoteCollectionStore.actions.sign,
      { entity: workNote, signature }
    );
  }
}
